/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from 'components/button'
import LoadingScreen from 'components/loading-screen'
import { useEffect, useState, VoidFunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import useWhiteBg from 'hooks/use-white-bg'
import useRouter from 'hooks/use-router'
import { useAgegate } from 'hooks/use-agegate'
import images from '../../images.json'
import { useSession } from '../../contexts/session-context'
import { useTrivia } from '../../contexts/trivia-context'
import { HeaderST, ButtonMenu, SpanMenu, Menu, Logo, Points } from '../../theme/header'
import { Main } from '../../theme/theme'
import { SubTitleHeader, TextHeader, TextLevel, TitleHeader } from './text.style'

const routesLinks = THEME_CONFIG.routesLinks

const Header: VoidFunctionComponent = () => {
  const { getAgeData, saveAgeData } = useAgegate();
  const [session] = useSession()
  const [open, setOpen] = useState(false)
  const { location, history, pathname } = useRouter()
  const logged = !!session.data
  const isTrivia = location.pathname.match(/\/trivia\/\d{1,3}$/)
  const [confirmationModal, setConfirmationModal] = useState<any>()
  const [loading, setLoading] = useState(false)
  const shouldUseWhiteBg = useWhiteBg()
  const [{ currentTrivia, error }, { validateTrivia, resetTrivia }] = useTrivia()
  const { showAgegate, recheckAge } = useAgegate()


  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
      return
    }
    document.body.style.overflow = 'auto'
    document.documentElement.style.overflow = 'auto'
  }, [open])

  useEffect(() => {
    recheckAge()
  }, [pathname])

  const toggle = (event: any) => {
    setOpen((isOpen) => !isOpen)
  }

  const onLinkClick = open
    ? (event: any) => {
      event.preventDefault()
      const url = event.target.getAttribute('data-url')

      if (isTrivia && !error) {
        setConfirmationModal({
          message: '¿Estás seguro que deseas salir de la trivia 1?',
          description: 'se perderá el progreso',
          func: async () => {
            setLoading(true)
            setConfirmationModal(null)
            await validateTrivia(currentTrivia?.id || 0, currentTrivia?.question.questionId || 0, 0)

            history.push(url)
          }
        })
      } else {
        if (isTrivia && currentTrivia && error) {
          resetTrivia()
        }
        history.push(url)
      }
      setOpen(false)
    }
    : undefined

  const logout = () => {
    const currentAgeGate = getAgeData();
    window.localStorage.clear()
    saveAgeData(currentAgeGate);
    window.location.href = `${process.env.PUBLIC_URL}/start`
  }

  const headerClasses = `w-full flex font-bold ${logged ? 'justify-between' : 'justify-center'} 
  ${open ? 'fixed z-50' : (logged && location.pathname === '/redeem') ? 'absolute z-30' : 'relative'}`
  const logoClasses = `w-20 ${logged ? 'ml-4' : ''}`.trim()
  const name = session.user?.firstName?.split(' ')[0]

  if (loading) {
    return <LoadingScreen></LoadingScreen>
  }

  if (confirmationModal) {
    return (
      <Main
        className="absolute w-screen h-screen min-h-view top-0 left-0 flex p-7 flex-col justify-center z-50 gap-8"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${images['background-main-red']})` }}
        shouldUseWhiteBg={false}
      >
        <h1 className="uppercase text-3xl text-center font-bold">{confirmationModal.message}</h1>
        <p className="uppercase din text-center">{confirmationModal.description}</p>
        <Button>
          <p className="din uppercase" onClick={confirmationModal.func}>
            aceptar
          </p>
        </Button>
        <button>
          <p
            onClick={() => {
              setConfirmationModal(null)
            }}
          >
            CANCELAR
          </p>
        </button>
      </Main>
    )
  }

  return (
    <HeaderST
      open={open}
      className={headerClasses}
      onClick={(event: any) => {
        const url = event.target.getAttribute('data-url')
        if (url) {
          if (isTrivia && !error) {
            setConfirmationModal({
              message: '¿Estás seguro que deseas salir de la trivia?',
              description: 'se perderá el progreso',
              func: async () => {
                try {
                  setLoading(true)
                  setConfirmationModal(null)
                  await validateTrivia(currentTrivia?.id || 0, currentTrivia?.question.questionId || 0, 0)
                } catch (error) {
                  console.log(error)
                } finally {
                  setLoading(false)
                  history.push(url)
                }
              }
            })
          } else {
            if (isTrivia && currentTrivia && error) {
              resetTrivia()
            }
            history.push(url)
          }
        }
      }}
    >
      <button data-url="/home" onClick={onLinkClick} className="h-24">
        <Logo
          data-url="/home"
          className={logoClasses}
          src={`${AZURE_BASE_URL}${showAgegate ? open || shouldUseWhiteBg ? images['logo-positivo-svg'] : images['logo-svg'] : images['logo-svg']}`}
          alt={`Logo de ${PROJECT_NAME}`}
        />
      </button>
      {logged && (
        <ButtonMenu open={open} className="w-24 h-24 p-8" onClick={toggle}>
          <SpanMenu
            open={open}
            className={`transition block h-0.5 w-8 ${open ? 'transform rotate-45 -mb-0.5' : 'mb-2'}`}
          />
          <SpanMenu
            open={open}
            className={`transition block h-0.5 w-8 ${open ? 'transform -rotate-45 -mb-0.5' : 'mb-2'}`}
          />
          <SpanMenu open={open} className={`block h-0.5 w-8 ${open ? 'hidden' : ''}`} />
        </ButtonMenu>
      )}
      {open && (
        <Menu
          className=" w-full fixed top-24 p-6 flex flex-col justify-between z-50 overflow-auto"
          style={{ height: 'calc(calc(var(--vh, 1vh) * 100) - 6rem)' }}
        >
          <div className="text-3xl uppercase">
            <TitleHeader>
              <p className="max-w-full">
                Hola, {name}
              </p>
              {
                THEME_CONFIG?.usePoints ?
                  <p>Ya tienes&nbsp;
                    <>
                      <Points className="inline">
                        <span className="mr-1">{session.user?.totalPoints || 0}</span> {POINTS_NAME}
                      </Points>
                    </>
                  </p>
                  : <></>
              }
            </TitleHeader>
            {
              session?.user?.level && THEME_CONFIG?.usePoints &&
              <div className="w-full flex items-center gap-2 my-4 text-base">
                <div className='bg-white rounded-full m-1'>
                  <img src={session?.user?.level?.imageUrl} alt={session?.user?.level?.name} className="h-18" />
                </div>
                <TextLevel>{session?.user?.level?.name}</TextLevel>
              </div>
            }
          </div>
          <ul className="text-2xl space-y-4">
            {routesLinks.map((link) => {

              if (link.small) {
                return (
                  <TextHeader
                    className='w-full sm:w-72 din font-normal text-sm text-left mb-2 uppercase'
                    key={`link-${link.path}-${link.text}`}
                  >
                    <Link to={link.path} className="w-full sm:w-72" onClick={onLinkClick} data-url={link.path}>
                      {link.text}
                    </Link>
                  </TextHeader>
                )
              }

              return (
                <SubTitleHeader
                  className='uppercase text-xl'
                  key={`link-${link.path}-${link.text}`}
                >
                  <Link to={link.path} className="w-full sm:w-72" onClick={onLinkClick} data-url={link.path}>
                    {link.text}
                  </Link>
                </SubTitleHeader>
              )
            })}
            <li>
              <button>
                <TextHeader className="w-full sm:w-72 font-normal text-sm text-left uppercase underline" onClick={logout}>
                  Cerrar Sesión
                </TextHeader>
              </button>
            </li>
          </ul>
        </Menu>
      )}
    </HeaderST>
  )
}

export default Header
